export class BackgroundManager extends Phaser.Group {
        
	constructor(game: Phaser.Game) {

		super(game, null, "background-manager");
		
		const backgroundImage = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "board-background.png");
		this.add(backgroundImage);	
	}
}
